module.exports = __webpack_public_path__ + "img/54-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO4.b347d60b.jpg";